// Every section's page loader (its lazy chunk): the nav entries' (routes/<Section>.nav.ts) plus Lisää
// and Asenna. The router (routes.tsx) makes its lazy pages of them; the loading screen's sections step
// (sections.warmup.ts) loads them all on a cold start. Light: no page is imported here.
import type { ComponentType } from 'react';
import { NAV_ENTRIES, type NavId } from './nav';
import type { NavEntry } from './nav-entry';

export const LOADERS = Object.fromEntries(NAV_ENTRIES.map((e) => [e.id, e.load])) as Record<NavId, NavEntry['load']>;
export const loadMore = () => import('../routes/More');
export const loadInstall = () => import('../routes/Install');

/** In nav order, then Lisää and Asenna. */
export const pageLoaders = (): (() => Promise<{ default: ComponentType }>)[] => [...NAV_ENTRIES.map((e) => e.load), loadMore, loadInstall];

let warmed = false;
/** The sections step has loaded them (the idle-time preload then has nothing to do). */
export const pagesWarmed = (): boolean => warmed;

/** Every section chunk, one at a time, with progress; rejects when one failed (the rest still load). */
export async function loadPages(progress: (f: number) => void): Promise<void> {
  warmed = true;
  const all = pageLoaders();
  let failed: unknown = null;
  for (const [i, load] of all.entries()) {
    await load().catch((e: unknown) => (failed ??= e));
    progress((i + 1) / all.length);
  }
  if (failed) throw failed;
}
